import { render, staticRenderFns } from "./RemoveIcon.vue?vue&type=template&id=5283e862"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5283e862')) {
      api.createRecord('5283e862', component.options)
    } else {
      api.reload('5283e862', component.options)
    }
    module.hot.accept("./RemoveIcon.vue?vue&type=template&id=5283e862", function () {
      api.rerender('5283e862', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/RemoveIcon.vue"
export default component.exports